import type { NavDropdownItem, NavItem, NavMegaMenu } from '../types/navigation';

export const RESOURCE_ITEMS: NavDropdownItem[] = [
  { label: 'Ebooks Gratuitos', href: '#' },
  { label: 'Glosario', href: '#' },
  { label: 'Investigaciones', href: '#' },
  { label: 'Noticias', href: '#' },
  { label: 'Newsletter', href: '#' },
  { label: 'Podcast Adipados', href: '#' },
];

export const DISCOVER_MEGA_MENU: NavMegaMenu = {
  defaultGroupId: 'institucional',
  categories: [
    { label: 'Nosotros', sectionId: 'institucional' },
    { label: 'Comunidad', sectionId: 'comunidad' },
    { label: 'Beneficios', sectionId: 'beneficios' },
    { label: 'Categorías', sectionId: 'categorias' },
    { label: 'Rutas', sectionId: 'rutas' },
    { label: 'Capacitación Institucional', sectionId: 'capacitacion' },
  ],
  groups: [
    {
      id: 'institucional',
      label: 'Institucional',
      links: [
        { label: 'Sobre ADIPA', href: '#' },
        { label: 'Explora las Escuelas de ADIPA', href: '#' },
        { label: 'Docentes', href: '#' },
        { label: 'Impacto', href: '#' },
        { label: 'Sala de Prensa', href: '#' },
        { label: 'Trabaja con nosotros', href: '#' },
      ],
    },
    {
      id: 'comunidad',
      label: 'Comunidad',
      links: [
        { label: 'Concurso: En tus Palabras', href: '#' },
        { label: 'Encuentra Empleos', href: '#' },
        { label: 'Eventos', href: '#' },
        { label: 'Testimonios', href: '#' },
      ],
    },
    {
      id: 'beneficios',
      label: 'Beneficios',
      links: [
        { label: 'Convenios', href: '#' },
        { label: 'Programa Adipartners', href: '#' },
        { label: 'Curso gratis de cumpleaños', href: '#' },
      ],
      secondaryAction: { label: 'Ver todos', href: '#' },
    },
    {
      id: 'categorias',
      label: 'Categorías de formación',
      links: [
        { label: 'Psicología Clínica', href: '#' },
        { label: 'Neuropsicología', href: '#' },
        { label: 'Psicoterapia', href: '#' },
        { label: 'Infanto Juvenil', href: '#' },
        { label: 'Salud Mental Comunitaria', href: '#' },
      ],
    },
    {
      id: 'rutas',
      label: 'Rutas sugeridas',
      links: [
        { label: 'Ruta de Trauma y Apego', href: '#' },
        { label: 'Ruta de Evaluación Integral', href: '#' },
        { label: 'Ruta de Intervención Breve', href: '#' },
        { label: 'Ruta de Liderazgo Clínico', href: '#' },
      ],
    },
    {
      id: 'capacitacion',
      label: 'Capacitación Institucional',
      links: [
        { label: 'Programas para equipos de salud', href: '#' },
        { label: 'Formación para comunidades educativas', href: '#' },
        { label: 'Capacitaciones in-company', href: '#' },
        { label: 'Diagnóstico y plan formativo', href: '#' },
      ],
      secondaryAction: { label: 'Contactar al equipo', href: '#' },
    },
  ],
};

export const GLOBAL_NAV_ITEMS: Omit<NavItem, 'active'>[] = [
  { label: 'Descubre ADIPA', href: '#', megaMenu: DISCOVER_MEGA_MENU },
  { label: 'Recursos', href: '#', dropdown: RESOURCE_ITEMS },
  { label: 'Seminarios', href: '#', badge: 'GRATIS', badgeColor: 'brand' },
  { label: 'Congreso', href: '#', badge: 'NUEVO', badgeColor: 'magenta' },
  { label: 'Especializaciones', href: '#' },
  { label: 'Acreditaciones', href: '#' },
  { label: 'Cursos', href: '/cursos' },
  { label: 'Sesiones Magistrales', href: '#' },
  { label: 'Diplomados', href: '#' },
];

export const shouldMarkAsActive = (href: string, pathname: string): boolean => {
  if (!href.startsWith('/')) {
    return false;
  }

  if (href === '/cursos') {
    return pathname.startsWith('/cursos');
  }

  return pathname === href;
};
